import localForage from "localforage";
import { hashCode } from './tools';

const MAXIMUM_MESSAGE_SIZE = 10000;
let seq = 1000;
let progressbar = false;

window.ihp2p = {
  image,
  http,
  upload,
};

const bufferImage = {};
const bufferHttp = { count: 0 };
const bufferUpload = { count: 0 };

export function send(data) {
  if (seq > 9999) {
    seq = 1000;
  } else {
    seq++;
  }

  const temp = JSON.stringify(data)
  const l = temp.length;
  if (l > MAXIMUM_MESSAGE_SIZE) {
    for (var i = 0; i < l; i = i + MAXIMUM_MESSAGE_SIZE) {
      if (i === 0) {
        window.ihp2p.peer.write('1' + seq.toString() + temp.slice(i, i + MAXIMUM_MESSAGE_SIZE))
      } else {
        if (i + MAXIMUM_MESSAGE_SIZE <= l) {
          window.ihp2p.peer.write('2' + seq.toString() + temp.slice(i, i + MAXIMUM_MESSAGE_SIZE))
        } else {
          window.ihp2p.peer.write('3' + seq.toString() + temp.slice(i, i + MAXIMUM_MESSAGE_SIZE))
        }
      }
    }
  } else {
    window.ihp2p.peer.write('0' + temp);
  }
}

function socket() {
  window.ihp2p.connection.socket.send = ws;
  window.ihp2p.connection.socket.onopen();
}

function progress(length, tollbar) {
  if (progressbar) {
    tollbar({ type: 'next', length });
  }
}

function message(data, tollbar) {
  let msg = "";
  if (data.length > 3000000) {
    const test = data.replace(/:\\pE;/g, " ");
    msg = JSON.parse(test);
  } else {
    msg = JSON.parse(data);
  }

  switch (msg.type) {
    case 'progress_start':
      resProgressStart(msg.length, tollbar);
      break;
    case 'progress_stop':
      resProgressStop();
      break;
    case 'bundle':
      resBundle(msg);
      break;
    case 'ws':
      window.ihp2p.connection.socket.onmessage(msg);
      break;
    case 'image':
      resImage(msg);
      break;
    case 'http':
      resHttp(msg);
      break;
    case 'upload':
      resUpload(msg);
      break;
    default:
      break;
  }
}

function resBundle(msg) {
  if (msg.data === null) {
    localForage.getItem(`${msg.token}_${msg.mode}_bundle`)
      .then(data => {
        window.eval(data);
        socket();
      });
  } else {
    localForage.setItem(`${msg.token}_${msg.mode}`, msg.cacheid);
    localForage.setItem(`${msg.token}_${msg.mode}_bundle`, msg.data);
    window.eval(msg.data);
    socket();
  }
}

function resProgressStart(length, tollbar) {
  progressbar = true;
  tollbar({ type: 'chunk', length });
}

function resProgressStop() {
  progressbar = false;
}

function resImage(msg) {

  const id = hashCode(msg.url);

  bufferImage[id].data = 'data:' + bufferImage[id].type + ';base64,' + msg.data
  bufferImage[id].enabled = true;

  bufferImage[id].queue.forEach(i => {
    if (i.nodeName === 'IMG') {
      i.setAttribute('src', bufferImage[id].data);
    } else {
      i.style.backgroundImage = 'url(' + bufferImage[id].data + ')';
    }
  });

  bufferImage[id].queue = false;
}

function resHttp(msg) {
  if (bufferHttp[msg.id]) {
    if (msg.data) {
      if (msg.binary) {
        bufferHttp[msg.id].resolve({ filename: msg.filename, data: msg.data });
      } else {
        bufferHttp[msg.id].resolve(msg.data);
      }
    } else {
      bufferHttp[msg.id].reject();
    }
    delete bufferHttp[msg.id];
  }
}

function resUpload(msg) {
  if (bufferUpload[msg.id]) {
    if (msg.name) {
      bufferUpload[msg.id].resolve(msg.name);
    } else {
      bufferUpload[msg.id].reject();
    }
    delete bufferUpload[msg.id];
  }
}

function ws(data) {
  send({ type: 'ws', data });
}

function image(img, url, name) {
  if (name) {
    const id = hashCode(url);
    const type = name.slice(-3) === 'svg' ? 'image/svg+xml' : 'image/png';

    if (!bufferImage.hasOwnProperty(id)) {
      bufferImage[id] = { data: '', name, enabled: false, queue: [img], type };
      send({ type: 'image', name, url });
    } else {
      if (bufferImage[id].enabled) {
        if (img.nodeName === 'IMG') {
            img.setAttribute('src', bufferImage[id].data);
        } else {
          img.style.backgroundImage = 'url(' + bufferImage[id].data + ')';
        }
      } else {
        bufferImage[id].queue.push(img);
      }
    }
  }
}

function http(url, binary = false) {
  bufferHttp.count++;
  return new Promise((resolve, reject) => {
    bufferHttp[bufferHttp.count] = { resolve, reject };
    send({ type: 'http', url, id: bufferHttp.count, binary });
  });
}

function upload(filename, params, data) {
  bufferUpload.count++;
  return new Promise((resolve, reject) => {
    bufferUpload[bufferUpload.count] = { resolve, reject };
    send({ type: 'upload', filename, params, data, id: bufferUpload.count });
  });
}

export default {
  send,
  message,
  progress,
};



// WEBPACK FOOTER //
// ./src/lib/gateway.js